import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/appagent/src/app/(landing)/LandingShell.tsx");
